import StarIcon from './StarIcon'

export {StarIcon}
export default StarIcon
